module.exports = __webpack_public_path__ + "4b034d3102ceb69d03c4b6de0ad56473.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/new_york.jpg
// module id = 604
// module chunks = 0